/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-sub-hidden";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "ja";
export const localeOptions = [
  { id: "en", name: "English", direction: "ltr" },
  { id: "ja", name: "日本語", direction: "ltr" },
];

export const searchPath = "/app/pages/search";
export const servicePath = "localhost:8080";

/* 
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const themeColorStorageKey = "__theme_color";
export const isMultiColorActive = false;
export const isDarkSwitchActive = false;
export const defaultColor = "light.green";
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;
